import { useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import trackingUserHistoryAct from '../../../../redux/actions/conversations/plugins/trackingUserHistoryAct'

function usePluginTrackingHistory({ userId }) {
  const dispatch = useDispatch()
  const { conversations } = useSelector(store => store)
  const currentConversation = conversations[userId]

  const { isOpen = false, isLoading = false, history = [] } = currentConversation?.plugins?.trackingUserHistory || {}

  useEffect(
    () => {
      if (isOpen && userId) {
        dispatch(trackingUserHistoryAct.get())
      }
    },
    [userId, isOpen]
  )

  const onClickCollapse = useCallback(
    () => {
      dispatch(isOpen ? trackingUserHistoryAct.close() : trackingUserHistoryAct.open())
    },
    [isOpen]
  )

  if (!userId) return null

  return {
    history,
    isOpen,
    isLoading,
    onClickCollapse
  }
}

export default usePluginTrackingHistory